import type { MapHtmlContent, MapSurface } from '@gpx-spa/geo-domain'

export function escapeHtml(text: string): string {
  return text
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
}

export function htmlFromMapContent(content: MapHtmlContent): string {
  if (content.format === 'html') return content.value
  return `<div>${escapeHtml(content.value)}</div>`
}

export function htmlFromMapSurface(surface: MapSurface): string {
  return htmlFromMapContent(surface.content)
}
